var _circle, _circle2, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-life-buoy",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 4.93,
    x2: 9.17,
    y2: 9.17
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.83,
    y1: 14.83,
    x2: 19.07,
    y2: 19.07
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.83,
    y1: 9.17,
    x2: 19.07,
    y2: 4.93
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14.83,
    y1: 9.17,
    x2: 18.36,
    y2: 5.64
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 19.07,
    x2: 9.17,
    y2: 14.83
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeRing);
export default __webpack_public_path__ + "static/media/life-ring.f2aeaeaf64fbc44f283112d92dbfbfdb.svg";
export { ForwardRef as ReactComponent };